import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { InterviewLayout } from '../components/templates/InterviewLayout.js';
import { Button } from '../components/atoms/Button.js';
import { Typography } from '../components/atoms/Typography.js';
import { Card } from '../components/atoms/Card.js';
import { ConsentCheckbox } from '../components/molecules/ConsentCheckbox.js';
import { useInterviewStore } from '../stores/interview-store.js';

export function PrivacyConsentPage() {
  const { t } = useTranslation('interview');
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const setConsent = useInterviewStore((s) => s.setConsent);
  const [agreed, setAgreed] = useState(false);

  const handleProceed = () => {
    setConsent(true);
    navigate(`/survey/${token}/chat`);
  };

  return (
    <InterviewLayout title={t('consent_page.title')}>
      <div className="flex flex-1 flex-col items-center justify-center gap-6">
        <Card padding="lg" className="w-full">
          <Typography variant="h3" className="mb-4">
            {t('consent_page.privacy_title')}
          </Typography>
          <div className="mb-6 space-y-3 text-sm text-neutral-600">
            <p>{t('consent_page.description_1')}</p>
            <p>{t('consent_page.description_2')}</p>
            <p>{t('consent_page.description_3')}</p>
          </div>

          <div className="mb-6">
            <ConsentCheckbox checked={agreed} onChange={setAgreed} />
          </div>

          <Button size="lg" disabled={!agreed} onClick={handleProceed} className="w-full">
            {t('consent_page.start_button')}
          </Button>
        </Card>
      </div>
    </InterviewLayout>
  );
}
